import { render, staticRenderFns } from "./index.vue?vue&type=template&id=719ba657&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719ba657",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('719ba657')) {
      api.createRecord('719ba657', component.options)
    } else {
      api.reload('719ba657', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=719ba657&scoped=true&", function () {
      api.rerender('719ba657', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/nested/menu1/menu1-1/menu1-1-1/menu1-1-1-1/index.vue"
export default component.exports